import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { DateUtils, UrlUtils } from '@atlassian/mpac-utils';
import invariant from 'invariant';
import queryString from 'query-string';
import { partnerReportsRoute } from "../../../constants/Routes";
import { defaultFilters } from "./defaultFilters";
export const getNewReportPathname = (partnerId, currentReportName, shouldAppendUrl, selectedOptionValue) => UrlUtils.resolveUrlFromTemplateAndParameters({
  template: UrlUtils.transformRoutePathToUriTemplate({
    routePath: partnerReportsRoute.path
  }),
  parameters: {
    partnerId,
    reportName: shouldAppendUrl ? selectedOptionValue : currentReportName
  }
});
export const getNewSearch = (currentParams, selectedOptionQueryParam, selectedOptionValue) => {
  if (!selectedOptionQueryParam) {
    invariant(selectedOptionValue, 'selected option value is required');
    return "?".concat(queryString.stringify(defaultFilters[selectedOptionValue]));
  }

  const newParams = {
    [selectedOptionQueryParam]: selectedOptionValue
  };

  if (selectedOptionQueryParam === 'period' && selectedOptionValue === 'custom') {
    newParams.startDate = DateUtils.ISOFormatHyphenatedDate(DateUtils.subtractDateByDays(new Date(), 30));
    newParams.endDate = DateUtils.ISOFormatHyphenatedDate(new Date());
  }

  return "?".concat(queryString.stringify(_objectSpread(_objectSpread({}, currentParams), newParams)));
};